import { colors } from '@material-ui/core';

const overrides = {
  root: {
    backgroundColor: colors.grey[50],
  },
};
export default overrides;
